import { render, staticRenderFns } from "./ProjectTaskStatistics.vue?vue&type=template&id=5be65849&scoped=true"
import script from "./ProjectTaskStatistics.vue?vue&type=script&lang=js"
export * from "./ProjectTaskStatistics.vue?vue&type=script&lang=js"
import style0 from "./ProjectTaskStatistics.vue?vue&type=style&index=0&id=5be65849&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be65849",
  null
  
)

export default component.exports